import dynamic from "next/dynamic";

export const JobPostHero = dynamic(() => import("./component"));
